const ExtraSection = () => {
  return (
    <div className="col-lg-6 col-12 d-lg-flex d-none extra-section flex-column">
      <i className="fab fa-cloudversify"></i>
      <h1 className="brand-name">سامانه پایش دارستان صنعت</h1>
      <hr />
    </div>
  );
}

export default ExtraSection;
